<template>
  <form-builder-editor-field
    :item="item"
    :show-hide-in-form="true"
    :show-hide-in-preview="true"
    :show-hide-in-reports="true"
    :show-required="true"
    :show-share-with-participant="true"
    :show-is-shared="true"
    v-on="$listeners"
  >
    <editor-options-list
      :values="item.values"
      :id="item.name"
      :show-templates="true"
    />
  </form-builder-editor-field>
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";
import EditorOptionsList from "./EditorOptionsList";

export default {
  components: {EditorOptionsList, FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    },
  },

  setup() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// FormBuilderEditorCheckboxGroup.vue?37cc7018